import Utils from './utils';

const RETAIL360 = {

	init() {
		this.prepareCookie();
		this.handleRetail360Popup();
	},

	/**
	 * Trigger Retail360 popup based on cookie.
	 */
	handleRetail360Popup() {

		const popupHandler = () => {

			const popupIDs = this.getRetail360PopupIDs();
			const cookie = GLBLCOKIE.get( false );

			if ( ! popupIDs || ! cookie ) {
				return;
			}

			if ( ! cookie.showRetail360Popup ) {
				return;
			}

			const popupIdList = popupIDs.split( ',' );

			if ( 0 >= popupIdList.length ) {
				return;
			}

			popupIdList.forEach( ( popupID ) => {

				popupID = Number( popupID );
				if ( isNaN( popupID ) ) {
					return;
				}

				const popupCssID = `popmake-${popupID}`;
				const key = 'popup_' + popupCssID + '_closed';
				const popupClosed = window.sessionStorage.getItem( key );
				if ( popupClosed ) {
					return;
				}

				const closeButton = jQuery( `#${popupCssID} .popmake-close` );
				closeButton.on( 'click', () => {
					window.sessionStorage.setItem( key, true );
				} );

				// Check if the popup exists
				if ( ( 'undefined' !== typeof PUM ) && PUM.getPopup( popupID ).length ) {

					// Open the popup with the given popupID
					PUM.open( popupID );
				}
			} );
		};

		const gravityFormHandler = () => {

			const cookie  = GLBLCOKIE.get( false );
			const gformID = this.getRetail360GformID();

			if ( ! cookie || ! gformID ) {
				return;
			}

			gformID = Number( gformID.trim() );
			if ( ! isNaN ( gformID ) ) {

				jQuery( document ).ready( function() {
					jQuery( document ).on( 'gform_confirmation_loaded', function( event, formId ) {

						if ( gformID === formId ) {

							const latestCookie = GLBLCOKIE.get( false );
							latestCookie.showRetail360Popup = false;
							GLBLCOKIE.update( Utils.serialize( latestCookie ) );
						}
					} );
				} );
			}
		};

		popupHandler();
		gravityFormHandler();

	},

	/**
	 * Prepare the cookie ( Add showRetail360Popup key to existing global cookie if not exist ).
	 */
	prepareCookie() {

		const cookie = GLBLCOKIE.get( false );

		if ( ! cookie ) {
			return;
		}

		if ( ! cookie.hasOwnProperty( 'showRetail360Popup' ) ) {
			cookie.showRetail360Popup = true;
			GLBLCOKIE.update( Utils.serialize( cookie ) );
		}
	},

	/**
	 * Get Retail360 Popup IDs.
	 */
	getRetail360PopupIDs() {

		return GLBLCOKIE.storage.options.Retail360Popup;

	},

	/**
	 * Get Retail360 Gform ID.
	 */
	getRetail360GformID() {

		return GLBLCOKIE.storage.options.Retail360Gform;

	}

};

export default RETAIL360;
